import { NoRecordFound, PageLoader, Iconify, Button, ButtonVariant } from "@repo/design-system/components/ui";
import PropTypes from "prop-types";
import "./DataStateHandler.scss";

export const DataStateHandler = ({
    isLoading,
    isFetching,
    data,
    noDataMessage = "No records found",
    children,
    loaderClass = "dataset-handler",
    isEnabledImage = true,
    isEnabledIcon,
    isError = false,
    errorTitle = "Oops! Something Went Wrong",
    errorMessage = "An unexpected error occurred. Please try again later.",
    errorIcon = "lucide:triangle-alert",
    isEnabledErrorIcon = true,
    errorClassName = "",
    onRetry
}) => {

    const hasData = Array.isArray(data) ? data.length > 0
        : data && typeof data === "object" ? Object.keys(data).length > 0 : false;


    // Show loader while API is in progress
    if (isLoading || isFetching) {
        return <PageLoader loaderClass={loaderClass} />;
    }

    // Show error state if api failed
    if (isError) {
        return (
            <div className={`data-state-error ${errorClassName}`}>
                {isEnabledErrorIcon && (
                    <div className="error-icon-container">
                        <Iconify icon={errorIcon} />
                    </div>
                )}
                <h5 className="error-title">{errorTitle}</h5>
                <p className="error-message">{errorMessage}</p>
                {onRetry && (
                    <Button variant={ButtonVariant.OUTLINE} onClick={onRetry}
                        leftIcon="lucide:refresh-cw" className="error-retry-btn">
                        Retry
                    </Button>
                )}
            </div>
        );
    }

    // Show no records only after API completes
    if (!hasData) {
        return (
            <NoRecordFound
                message={noDataMessage}
                isEnabledImage={isEnabledImage}
                isEnabledIcon={isEnabledIcon}
            />
        );
    }

    return <>{children}</>;
};

DataStateHandler.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    data: PropTypes.array,
    noDataMessage: PropTypes.string,
    children: PropTypes.node.isRequired,
    loaderClass: PropTypes.string,
    isEnabledImage: PropTypes.bool,
    isEnabledIcon: PropTypes.bool,
    isError: PropTypes.bool,
    errorTitle: PropTypes.string,
    errorMessage: PropTypes.string,
    errorIcon: PropTypes.string,
    isEnabledErrorIcon: PropTypes.bool,
    errorClassName: PropTypes.string,
    onRetry: PropTypes.func
};

